/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ====================== Blossom ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist

if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu.beforeActivation("catnav,landing", function (data, scope) {

    scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);

    scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });

    (function (klevu) {
        klevu.extend(true, klevu.search.modules, {
            addParamsToURL: {
                base: {
                    addURLtoHistory: function (data, scope, queryId) {
                        // Global stuff
                        if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                            console.error("This browser does not have the support of window.history or window.history.pushState");
                            return;
                        }

                        var searchPath = new URLSearchParams(window.location.search);
                        var currentSearchPath;
                        var previousSearchPath = searchPath.toString();

                        // this is in case we're running our code where we dont have context.activeQueryId
                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                        if (queryId && queryId.length) {
                            activeQueryId = queryId;
                        }

                        // Check if there any filter selected
                        let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                        let isThereFiltersSelected = false;
                        // Check if applyFilters is an object (but not an array), and not empty
                        if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                            isThereFiltersSelected = true;
                        }

                        // PAGINATION TO URL
                        var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                        var paginationQueryParam = "Page";
                        var currentPage = 0;

                        if (hasPaginationEnabled) {
                            var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                            if (activeQueryMeta) {
                                var productListLimit = activeQueryMeta.noOfResults;
                                currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                            }

                            if (currentPage === 0 || currentPage === 1) {
                                searchPath.delete(paginationQueryParam);
                            } else {
                                searchPath.set(paginationQueryParam, currentPage);
                            }

                            currentSearchPath = searchPath.toString();
                        };

                        // FILTERS TO URL
                        var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                        var filterValuesQueryParam = "";

                        if (activeQueryFilters) {
                            klevu.each(activeQueryFilters, function (key, filter) {
                                var selectedFilterKeyString = "";
                                var filterOptions = filter.options;
                                var selectedValues = "";

                                if (filterOptions && filterOptions.length) {
                                    klevu.each(filterOptions, function (key, option) {
                                        if (option.selected === true) {
                                            if (selectedValues.length) {
                                                selectedValues += ",";
                                            }
                                            selectedValues += option.value;
                                        }
                                    });
                                } else if (filter.type === "SLIDER") {
                                    var startValue = filter.start;
                                    var endValue = filter.end;
                                    var minValue = filter.min;
                                    var maxValue = filter.max;
                                    if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                        if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                            // just skipping
                                        } else {
                                            selectedValues = startValue + "-" + endValue;
                                        }
                                    }
                                }

                                if (selectedValues.length) {
                                    // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                    selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                }

                                if (selectedFilterKeyString.length) {
                                    if (filterValuesQueryParam.length) {
                                        filterValuesQueryParam += ";";
                                    }
                                    filterValuesQueryParam += selectedFilterKeyString;
                                }
                            });
                        }

                        if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                            searchPath.set("Filters", filterValuesQueryParam);
                        } else {
                            searchPath.delete("Filters");
                        }

                        currentSearchPath = searchPath.toString();

                        // ==============================
                        // Final URL change
                        if (previousSearchPath !== currentSearchPath) {
                            var historyState = { page: currentPage, filters: currentSearchPath };
                            window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                        }
                    },

                    restoreSearchParamsOnPageLoad: function (data, scope) {
                        var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                        if (hasAlreadyTriggered) return;

                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

                        var matchedQueryParamId = "";
                        var matchedQueryParamValue = "";
                        var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id) {
                                    if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                        matchedQueryParamId = recordQuery.id;
                                        matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                    }
                                }
                            });
                        }

                        klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

                        matchedQueryParamId = activeQueryId || "productList";

                        if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                            activeQueryId = matchedQueryParamId;
                            var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                            if (storage.tabs) {
                                storage.tabs.setStorage("local");
                                storage.tabs.mergeFromGlobal();
                                storage.tabs.addElement("active", activeQueryId);
                                storage.tabs.mergeToGlobal();
                            }
                        }

                        if (paginationFromURL && paginationFromURL > 1) {
                            if (recordQueries && recordQueries.length) {
                                klevu.each(recordQueries, function (key, recordQuery) {
                                    if (recordQuery.id === activeQueryId) {
                                        var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                        limit = Number(limit);
                                        if (limit > 0) {
                                            var expectedOffset = (paginationFromURL - 1) * limit;
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                        }
                                    }
                                });
                            }
                        }

                        // FILTERS
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            if (facets) {
                                klevu.each(facets, function (key, facet) {
                                    var splitFacet = facet.split(":");
                                    if (splitFacet.length) {
                                        var facetKey = decodeURIComponent(splitFacet[0]);
                                        var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                        var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                                        if (applyFilters && applyFilters.length) { // if there're some filters
                                            var isExistingKey = false;
                                            klevu.each(applyFilters, function (key, applyFilter) {
                                                if (applyFilter.key === facetKey) {
                                                    isExistingKey = true;
                                                    klevu.each(facetValues, function (key, facetValue) {
                                                        var isFilterOptionMatched = false;
                                                        klevu.each(applyFilter.values, function (key, value) {
                                                            if (facetValue === value) {
                                                                isFilterOptionMatched = true;
                                                            }
                                                        });
                                                        if (!isFilterOptionMatched) {
                                                            applyFilter.values.push(facetValue);
                                                        }
                                                    });
                                                }
                                            });
                                            if (!isExistingKey) {
                                                applyFilters.push({ key: facetKey, values: facetValues });
                                            }
                                        } else {
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                        }

                                    }
                                });
                            }
                        }
                    },

                    updatePayloadOnPopState: function (data, scope, activeQueryId) {
                        // SET PAGINATION PAYLOAD
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                        paginationFromURL = Number(paginationFromURL);
                        var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
                        limit = Number(limit);
                        if (limit > 0) {
                            var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                            // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                        }

                        // SET FILTER PAYLOAD
                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            // loop through all facets to get its values
                            let facetKey = '';
                            let facetValues = [];
                            let facetsArray = [];

                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    facetKey = decodeURIComponent(splitFacet[0]);
                                    facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                    facetsArray.push({ key: facetKey, values: facetValues });
                                }
                            });
                            // set the payload with correct filters:
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                        } else { // reset filters if Back button pressed, and there's no filters
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                        }
                    }
                },
                build: true
            },
            filterOpener: function (data, scope) {
                var filterOpener = document.querySelector('.ku-facet-opener');
                var filterClose = document.querySelector('.ku-facet-close');
                var filterApply = document.querySelector('.kuFiltersMobButton_apply');
                var landingElement = document.querySelector('.klevuLanding');
                if (filterOpener && landingElement) {
                    klevu.event.attach(filterOpener, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
                if (filterClose && landingElement) {
                    klevu.event.attach(filterClose, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
                if (filterApply && landingElement) {
                    klevu.event.attach(filterApply, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
            },
            insertToTopButton: function (data, scope) {
                let topButton = document.getElementById('ku-back-to-top');
                if (!topButton) {
                    topButton = document.createElement('button');
                    topButton.id = 'ku-back-to-top';
                    topButton.title = 'Back to top';
                    topButton.className = 'ku-hide';
                    topButton.textContent = '↑';
                    document.body.appendChild(topButton);
                }

            },
            addBodyClassOnScroll: function () {
                // Helper function to get the top position of an element
                function getElementYPosition () {
                    var element = document.querySelector('.kuResultsListing');
                    if (element) {
                        var boundingClientRect = element.getBoundingClientRect();
                        var absoluteElementTop = boundingClientRect.top + window.pageYOffset;
                        return absoluteElementTop;
                    }
                    return null; // Return null if the element doesn't exist
                };
                window.addEventListener('scroll', function (e) {
                    const positionY = window.scrollY;
                    const productListPositionY = getElementYPosition();
                    const triggerPositionY = productListPositionY !== null ? productListPositionY : 100;
                    const body = document.body;
                    const shouldAddClass = positionY >= triggerPositionY;
                    body.classList.toggle('klevu-sticky', shouldAddClass);
                });
            },
            smoothScrollToProductListingTop: function () {
                let customOffset = 60;
                const selectorsToTriggerScrollToTop = {
                    pagination: '.kuPagination a',
                    scrollToTopButton: '#ku-back-to-top'
                    // filterOptions: '.klevuFilterOption',
                    // Add more selectors here as needed
                }
                function _smoothScrollToKlevuTop() {
                    setTimeout(function () {
                        var target = document.getElementsByClassName('klevuMeta')[0];

                        if (target) {
                            var topPosition = target.getBoundingClientRect().top + window.pageYOffset;

                            window.scrollTo({
                                top: topPosition - customOffset,
                                behavior: 'smooth'
                            });
                        }
                    }, 100);
                }
                Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                    document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
                });
            },
            keepFacetsWithSelectedOptionsOpened: function (data, scope) {
                const selectors = {
                    kuFilterBox: '.kuFilterBox',
                    kuSelected: '.kuSelected',
                    kuFilterNames: '.kuFilterNames',
                    kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
                    kuFilterHead: '.kuFilterHead',
                    kuFilterHeadExpand: '.kuFilterHead.kuExpand',
                    kuExpand: '.kuExpand',
                    kuCollapse: '.kuCollapse',
                    nouiElement: '.noUi-origin',
                    priceFacetBlock: '[data-filter="klevu_price"]',
                    kuFilterShowAll: '.kuFilterShowAll',
                    kuFilterCollapse: '.kuFilterCollapse',
                };
                /** Expand only filter headers by default */
                (function expandFilterHeaders() {
                    // Set only filter headers to expanded state
                    const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
                    kuFilterHeadElements.forEach(element => {
                        element.classList.add(selectors.kuCollapse.substring(1));
                        element.classList.remove(selectors.kuExpand.substring(1));
                    });
                }());

                // Regular checkbox-facets
                // Check if the required elements exist
                const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
                if (kuSelectedElements.length > 0) {
                    kuSelectedElements.forEach(selectedElement => {
                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);

                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);

                        // Rotate icon in the title 
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }

                        // Find the parent element with the class kuFilterNames.kuFilterCollapse
                        const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);

                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }
                    });
                }

                // Price slider facet
                var isThereAnyAppliedFacets = klevu.getObjectPath(
                    scope.kScope.data,
                    "localOverrides.query." +
                    scope.kScope.data.context.activeQueryId +
                    ".filters.applyFilters.filters"
                );
                const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
                if (isPriceFacetApplied) {
                    // Find the parent element with the class kuFilterNames.kuFilterCollapse
                    const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);

                    if (nouiElement) {
                        const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);

                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }

                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);

                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);

                        // Rotate icon in the title
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }
                    }
                }

                // Function-helper to find the parent element with a specified class
                function findParentWithClass(element, className) {
                    let parent = element.parentElement;
                    while (parent) {
                        if (parent.matches(className)) {
                            return parent;
                        }
                        parent = parent.parentElement;
                    }
                    return null; // No matching parent found
                }
            }
        });
    })(klevu);

})

// Apply the facets supplied in the current URL string
klevu.modifyRequest("catnav,landing", function (data, scope) {

    if (localStorage.getItem('klv_sort_productList') !== null) {
        localStorage.removeItem('klv_sort_productList');
    }

    klevu.each(data.request.current.recordQueries, function (key, query) { query.filters.filtersToReturn.options.limit = 21; });

    // Restore Search Params On Page Load
    klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

    // set the global scope
    window.klevuCurrentScope = scope.kScope;
});

klevu.afterTemplateRender("catnav,landing", function (data, scope) {
    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    klevu.search.modules.insertToTopButton(data, scope);
    klevu.search.modules.filterOpener(data, scope);
    klevu.search.modules.addBodyClassOnScroll();
    klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);
    klevu.search.modules.smoothScrollToProductListingTop(data, scope);
});

window.onpopstate = function (event) {
    try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
        // code to get ready to reset all the data
        var data = window.klevuCurrentScope.element.kObject.getScope().data;
        var scope = window.klevuCurrentScope.element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;

        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

        // Fire request, re-render results
        klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
    } catch (error) {
    }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateFiltersCustom = `
    <% if(data.query[dataLocal].filters.length > 0 ) { %>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
        <div class="kuFiltersMobButtons">
            <button class="kuFiltersMobButton kuFiltersMobButton_apply" tabindex="0" aria-label="Apply selected filters"><%= helper.translate("Apply")%></button>
            <button class="kuFiltersMobButton kuFiltersMobButton_reset kuFilterTagClearAll" tabindex="0" aria-label="Reset all filters">Reset</button>
        </div>
        <div class="filters-styling">

        <h2 class="kuFiltersTitleHeading"><%=helper.translate("Filters")%></h2>
        <div class="filters-nav">
            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                            <% if(filter.options.length >= 7 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                	<div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        	<% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
  							<div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
  								<div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
  							</div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>
            
            <!-- <div class="kuFiltersFooter">
            	<a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  			</div> -->
            
            
            </div>
            </div>
        </div>
        <button class="ku-facet-close" aria-label="Close"><span class="mobile-filter__close"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" class="icon icon__close uc__hideFacets" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg></span><%= helper.translate("")%></button>
    <% } %>
`;

var klevuLandingTemplateResultsCustom = `
    <div class="kuResultsListing">
        <div class="productList klevuMeta" data-section="productList">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div class="ku-text-found">
                        <% if (data?.settings?.categoryPath === undefined) { %>
                                <h2><%=data.query.productList.meta.totalResultsFound %> <%= helper.translate("PRODUCTS FOUND FOR") %> "<%=data.query.productList.meta.searchedTerm %>"</h2>
                        <% } else { %>
                                <h2><%= data.settings.categoryPath %> </h2>
                        <% } %>
                    </div>

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">                                
                                <%=helper.render('filters',scope,data,"productList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">

                                <header ku-block data-block-id="ku_landing_result_header">
                                <% 
                                    var lastPageResults = (Number(data.query.productList.meta.noOfResults) + Number(data.query.productList.meta.offset)) > data.query.productList.meta.totalResultsFound ? data.query.productList.meta.totalResultsFound : (Number(data.query.productList.meta.noOfResults) + Number(data.query.productList.meta.offset));
                                    var results = ((Number(data.query.productList.meta.offset) !== 0) ? Number(data.query.productList.meta.offset) : '') + ' - ' + lastPageResults;
                                    if(results > data.query.productList.meta.totalResultsFound){
                                        results = data.query.productList.meta.totalResultsFound;
                                    }
                                %>


                                <% if(helper.hasResults(data,"productList")) { %>
                                    <div class="sorting-container">
                                        <%=helper.render('sortBy',scope,data,"productList") %>
                                        <%=helper.render('limit',scope,data,"productList") %>
                                        <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                                        <%=helper.render('pagination',scope,data,"productList") %>
                                    </div>
                                <% } %>
                                <div class="results-container">
                                    <div class="ku-numberOfResults">showing <%= results %> of <%=data.query.productList.meta.totalResultsFound %></div>
                                    <button class="ku-facet-opener"><span>Filter </span></button>
                                    <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                                    <%=helper.render('filtersTop',scope,data,"productList") %>
                                    <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                                </div>


                                <div class="kuClearBoth"></div>
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"productList")) { %>
                                        <ul>
                                           <% helper.each(data.query.productList.result,function(key,item){ %>
                                            <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                    <li ku-product-block class="klevuProduct" data-id="<%= item.id %>">
                                                        <a href="<%= item.url %>" class="product-link klevuProductClick kuTrackRecentView" aria-label="Product-link" aria-label="Product link" data-id="<%=item.id%>">
                                                            <div class="kuProdWrap">
                                                                <div class="product-image">
                                                                    <div class="card__badge top left">
                                                                        <div class="product-labels-wrapper">
                                                                            <% 
                                                                            const hasNewTag = item.tags && (
                                                                                (Array.isArray(item.tags) && item.tags.some(tag => tag.toLowerCase() === 'new')) ||
                                                                                (typeof item.tags === 'string' && item.tags.toLowerCase().includes('new'))
                                                                            );

                                                                            const hasSalePrice = item.salePrice && parseFloat(item.salePrice) > 0 && 
                                                                                parseFloat(item.salePrice) < parseFloat(item.price.replace(/[^0-9.]/g, ''));
                                                                            %>

                                                                            <% if (hasNewTag) { %>
                                                                                <div class="product-labels col card--labels">
                                                                                    <div class="icon-container card--labels">
                                                                                        <span class="label--new">NEW</span>
                                                                                    </div>
                                                                                </div>
                                                                            <% } %>

                                                                            <% if (hasSalePrice) { %>
                                                                                <div class="product-labels col card--labels sale">
                                                                                    <% 
                                                                                    const originalPrice = parseFloat(item.price.replace(/[^0-9.]/g, ''));
                                                                                    const salePrice = parseFloat(item.salePrice.replace(/[^0-9.]/g, ''));
                                                                                    const discount = Math.round(((originalPrice - salePrice) / originalPrice) * 100);
                                                                                    %>
                                                                                    <div class="icon-container card--labels">
                                                                                        <span class="label--sale"><%= discount %>% Off</span>
                                                                                    </div>
                                                                                </div>
                                                                            <% } %>
                                                                        </div>
                                                                    </div>
                                                                    <img 
                                                                        src="<%= item.image || 'https://cdn.shopify.com/s/files/1/0608/8907/1747/files/placeholder_600x400_8474dce6-5161-44c6-a515-ec8f4ba6f854.svg?v=1730845211' %>" 
                                                                        alt="<%= item.id %>"
                                                                        onerror="this.onerror=null; this.src='https://cdn.shopify.com/s/files/1/0608/8907/1747/files/placeholder_600x400_8474dce6-5161-44c6-a515-ec8f4ba6f854.svg?v=1730845211';"
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                                <div class="product-details">
                                                                    <div class="product-info">
                                                                    <div class="product-details second">
                                                                        <h2 class="product-title"><%= item.name %></h2>        


                                                                         <% if (item.producer_full_name) { %>
                                                                            <p class="product-producer"><%= item.producer_full_name.replace('[', '').replace(']', '') %></p>
                                                                        <% } %>
                                                                    </div>
                                                                                                                               <div class="product-price-wrapper">
                                                                    <% 
                                                                        const regularPrice = parseFloat(item.price.replace(/[^0-9.]/g, '')) || 0;
                                                                        const saleAmount = item.salePrice ? parseFloat(item.salePrice.replace(/[^0-9.]/g, '')) : null;
                                                                        
                                                                        // Debug logging
                                                                        console.log('Price Debug:', {
                                                                            productName: item.name,
                                                                            regularPrice: regularPrice,
                                                                            saleAmount: saleAmount,
                                                                            rawPrice: item.price,
                                                                            rawSalePrice: item.salePrice,
                                                                            hasValidSale: saleAmount !== null && saleAmount >= 0 && saleAmount < regularPrice
                                                                        });
                                                                    %>
                                                                
                                                                    <% if (regularPrice === 0) { %>
                                                                        <div class="product-price">Contact for Price</div>
                                                                    <% } else if (saleAmount !== null && saleAmount >= 0 && saleAmount < regularPrice) { %>
                                                                        <div class="product-price">
                                                                            <span class=" product-price-original">$<%= saleAmount.toFixed(2) %></span>
                                                                                                                                                        <span class="product-price-sale">$<%= regularPrice.toFixed(2) %></span>

                                                                        </div>
                                                                    <% } else { %>
                                                                        <div class="product-price">$<%= regularPrice.toFixed(2) %></div>
                                                                    <% } %>
                                                                
                                                                    <% if (item.compared_at_price) { %>
                                                                        <div class="product-price-compare">Compare at: <%= item.compared_at_price %></div>
                                                                    <% } %>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                <% } %>
                                            <% }); %>                                        
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('pagination',scope,data,"productList") %>
                            <% } %>


                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>

                </div>
            </div>
        </div>

        <% if(data.query.contentList) { %>
            <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
                <div class="kuResultContent">
                    <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                        <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                            <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                                <div ku-block data-block-id="ku_landing_left_facets">

                                    <%=helper.render('filters',scope,data,"contentList") %>

                                </div>
                                <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_left_banner"></div>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">

                                <header ku-block data-block-id="ku_landing_result_header">
                                    <%=helper.render('filtersTop',scope,data,"contentList") %>
                                    <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <%=helper.render('limit',scope,data,"contentList") %>
                                        <%=helper.render('pagination',scope,data,"contentList") %>
                                    <% } %>
                                    <div class="kuClearBoth"></div> 
                                </header>

                                <div ku-block data-block-id="ku_landing_result_items">
                                    <div class="kuClearBoth"></div>
                                    <div class="kuResults">
                                        <% if(helper.hasResults(data,"contentList")) { %>
                                            <ul>
                                                <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                    <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                        <%=helper.render('contentBlock',scope,data,item) %>
                                                    <% }%>
                                                <% }); %>
                                            </ul>
                                        <% } else { %>
                                            <div class="kuNoRecordsFoundLabelTextContainer">
                                                <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                            </div>
                                        <% } %>
                                        <div class="kuClearBoth"></div>
                                    </div>
                                </div>
                                <div ku-block data-block-id="ku_landing_other_items">
                                    <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                                </div>
                                <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                                <div ku-block data-block-id="ku_landing_right_facets"></div>
                                <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_right_banner"></div>
                            </section>
                        </div>

                    </div>
                </div>
            </div>
        <% } %> 

    </div>
`;




klevu({
    theme: {
        modules: {
            resultInfiniteScroll: {
                quickSearch: { enable: true },
                searchResultsPage: { enable: true },
                categoryPage: { enable: true },
            }
        }
    }
});

klevu.afterTemplateRender("landing,catnav", function(data, scope) {
    let isLoading = false;
    let lastLoadedOffset = 0;

    // Loading function
    async function loadMoreProducts() {
        if (isLoading) return;

        try {
            // Get Klevu search scope
            const searchScope = klevu.search.landing.getScope();
            if (!searchScope) {
                return;
            }

            // Get current query data
            const queryId = "productList";
            const query = searchScope.data.template.query[queryId];
            if (!query) {
                return;
            }

            // Calculate next offset
            const currentResults = query.result.length;
            const limit = query.meta.limit || 24;
            const nextOffset = Math.ceil(currentResults / limit) * limit;

            // Prevent duplicate loads
            if (nextOffset === lastLoadedOffset) return;

            isLoading = true;
            lastLoadedOffset = nextOffset;

            // Update settings for next page
            searchScope.data.request.current.recordQueries[0].settings.offset = nextOffset;
            searchScope.data.context.settings = searchScope.data.context.settings || {};
            searchScope.data.context.settings.offset = nextOffset;

            // Show loading indicator
            const loadingIndicator = document.querySelector('.kuLoadingIndicator');
            if (loadingIndicator) {
                loadingIndicator.classList.add('active');
            }

            // Trigger search
            await klevu.search.landing.getScope().chains.request.build.fire();

            // Hide loading indicator
            if (loadingIndicator) {
                loadingIndicator.classList.remove('active');
            }

            isLoading = false;
        } catch (error) {
            isLoading = false;

            // Hide loading indicator on error
            const loadingIndicator = document.querySelector('.kuLoadingIndicator');
            if (loadingIndicator) {
                loadingIndicator.classList.remove('active');
            }
        }
    }

    // Scroll handler with Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const isMobile = window.innerWidth <= 749;

            if (entry.isIntersecting && isMobile) {
                loadMoreProducts();
            }
        });
    }, {
        threshold: 0.5,
        rootMargin: '0px'
    });

    // Observe loading indicator
    const loadingIndicator = document.querySelector('.kuLoadingIndicator');
    if (loadingIndicator) {
        observer.observe(loadingIndicator);
    }
});


window._klvReady = window._klvReady || [];
window._klvReady.push(function () {

    const klevuLandingTemplateSortByCustom = `
<div class="kuDropdown kuDropSortBy" role="listbox" aria-labelledby="dropdownLabel" aria-activedescendant="RELEVANCE">
    <!-- Label for the dropdown -->
    <div class="kuDropdownLabel" id="dropdownLabel">
        <span class="sort-label"><%=helper.translate("Sort: ")%></span>
        <%=helper.translate(helper.getSortByCustom(dataLocal))%>
    </div>

    <div class="kuDropdownOptions">
        <!-- Accessible options with aria-label for each option -->
        <div class="kuDropOption kuSort" id="RELEVANCE" data-value="RELEVANCE" role="option" aria-label="<%=helper.translate("Best Sellers")%>" aria-selected="true">
            <%=helper.translate("Best Sellers")%>
        </div>
        <div class="kuDropOption kuSort" id="NEW_ARRIVAL_DESC" data-value="NEW_ARRIVAL_DESC" role="option" aria-label="<%=helper.translate("Just Added")%>" aria-selected="false">
            <%=helper.translate("Just Added")%>
        </div>
        <div class="kuDropOption kuSort" id="NEW_ARRIVAL_ASC" data-value="NEW_ARRIVAL_ASC" role="option" aria-label="<%=helper.translate("Oldest")%>" aria-selected="false">
            <%=helper.translate("Oldest")%>
        </div>
        <div class="kuDropOption kuSort" id="NAME_ASC" data-value="NAME_ASC" role="option" aria-label="<%=helper.translate("Alphabetically")%>" aria-selected="false">
            <%=helper.translate("Alphabetically ")%>
        </div>
        <div class="kuDropOption kuSort" id="PRICE_ASC" data-value="PRICE_ASC" role="option" aria-label="<%=helper.translate("Price, low to high")%>" aria-selected="false">
            <%=helper.translate("Price, low to high")%>
        </div>
        <div class="kuDropOption kuSort" id="PRICE_DESC" data-value="PRICE_DESC" role="option" aria-label="<%=helper.translate("Price, high to low")%>" aria-selected="false">
            <%=helper.translate("Price, high to low")%>
        </div>
    </div>
</div>
`;

    klevu.beforeActivation("landing, catnav", function (data, scope) {
        scope.kScope.template.setTemplate(klevuLandingTemplateSortByCustom, 'sortBy', true)
        scope.kScope.template.setHelper("getSortByCustom", function (name) {
            var landingStorage = klevu.getGlobalSetting("storage");
            var sorting = (landingStorage.sort.getElement(name) == name) ? "Best Sellers" : landingStorage.sort.getElement(name);
            var returnedValue = "";
            switch (sorting) {
                case "RELEVANCE":
                    returnedValue = 'Best Sellers';
                    break;
                case "PRICE_ASC":
                    returnedValue = 'Price: Low to high';
                    break;
                case "PRICE_DESC":
                    returnedValue = 'Price: High to low';
                    break;
                case "NEW_ARRIVAL_DESC":
                    returnedValue = 'Just Added';
                    break;
                case "NEW_ARRIVAL_ASC":
                    returnedValue = 'Oldest';
                    break;
                case "NAME_ASC":
                    returnedValue = 'Alphabetically';
                    break;
                default:
                    returnedValue = 'Best Sellers';
                    break;
            }
            return returnedValue;
        });
    });
});



window._klvReady = window._klvReady || [];
window._klvReady.push(function () {
    klevu.afterTemplateRender('landing, catnav', function (data, scope) {
        const currentDocumentHeight = document.documentElement.scrollHeight;
        document.body.style.minHeight = `${currentDocumentHeight}px`;

        // reset minHeight if there are Filters or Sorting have been selected
        function resetMinHeightListener(selector, matchSelector) {
            if (document.querySelector(selector) === null) {
                return;
            }
            document.querySelector(selector).addEventListener('click', function ({ target }) {
                if (target.matches(matchSelector)) {
                    document.body.style.minHeight = '0';
                }
            });
        }

        // Call the function with different selectors and matchSelectors
        resetMinHeightListener('.klevuLanding .kuFilters', '.kuFilterBox .kuFilterNames ul li a, .kuFilterBox .kuFilterNames ul li a *');
        resetMinHeightListener('.kuFilterTagsContainer', '.kuFilterTagValue, .kuFilterTagValue *, .kuFilterTagClearAll, .kuFilterTagClearAll *');
        resetMinHeightListener('.kuSearchResultsPageContainer .kuDropdown', '.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption, .kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption *');

        // Add load more button listener
        const loadMoreButton = document.querySelector('.kuLoadingButton');
        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', function() {
                document.body.style.minHeight = '0';
                setTimeout(() => {
                    document.body.style.minHeight = `${document.documentElement.scrollHeight}px`;
                }, 100);
            });
        }
    });

    klevu.beforeActivation('landing, catnav', function (data, scope) {
        scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });
    });
});
//make sort by filter  act normally not as klevu has default behaviour
klevu.afterTemplateRender("landing, catnav", function (data, scope) {
    klevu.each(klevu.dom.find('.kuDropdownLabel'), function (key, value) {
        klevu.event.attach(value, "click", function (event) {
            if (event.target.matches('.kuDropdownLabel, .kuDropdownLabel *')) {
                klevu.dom.find("body")[0].classList.toggle('klevu-sorting-visible');
            }
        });
    });
});





document.addEventListener("DOMContentLoaded", function () {
    const targetElement = document.querySelector(".klevuLanding");

    if (targetElement) {
        const observer = new MutationObserver(function () {
            if (targetElement.classList.contains("ku-facet-open")) {
                document.body.classList.add("filter-is-active"); // Add the class to <body>
                document.body.style.overflow = "hidden"; // Disable scrolling
            } else {
                document.body.classList.remove("filter-is-active"); // Remove the class from <body>
                document.body.style.overflow = ""; // Restore scrolling
            }
        });

        observer.observe(targetElement, {
            attributes: true, // Observe changes to attributes
            attributeFilter: ["class"], // Only look at class changes
        });
    }
});

//add padding to the grid-container when filters are applied 
document.addEventListener("DOMContentLoaded", function () {
    const updateClass = () => {
        // Check if the viewport matches mobile/tablet sizes
        if (window.matchMedia("(max-width: 920px)").matches) {
            const parentContainer = document.querySelector("[data-block-id='ku_landing_result_items']");
            const filterTagsContainer = document.querySelector(".kuFilterTagsContainer");

            if (parentContainer) {
                if (filterTagsContainer && filterTagsContainer.offsetParent !== null) {
                    parentContainer.classList.add("with-filter-tags");
                } else {
                    parentContainer.classList.remove("with-filter-tags");
                }
            }
        }
    };

    updateClass();

    const interactionEvents = ["mousemove", "click"];
    interactionEvents.forEach(event => {
        document.body.addEventListener(event, updateClass);
    });

    // Use MutationObserver to detect dynamic changes
    const observer = new MutationObserver(() => {
        updateClass();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});




//set padding to grid base on width of filter 
document.addEventListener('DOMContentLoaded', function () {
    // Check if URL contains 'collection' or 'products' and if the screen width is <= 990px
    if ((window.location.href.includes('collection') || window.location.href.includes('products')) && window.innerWidth <= 990) {
        setTimeout(updatePadding, 500);
        observeMutations();
        addEventListeners();
    }
});

function addEventListeners() {
    window.addEventListener('mousemove', function () {
        if (window.innerWidth <= 990) {
            setTimeout(updatePadding, 500);
        }
    });

    window.addEventListener('click', function () {
        if (window.innerWidth <= 990) {
            setTimeout(updatePadding, 500);
        }
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth <= 990) {
            setTimeout(updatePadding, 500);
        }
    });

    window.addEventListener('scroll', function () {
        if (window.innerWidth <= 990) {
            setTimeout(updatePadding, 500);
        }
    });
}

function updatePadding() {
    const filterElement = document.querySelector('.kuFilterTagsContainer');
    const grid = document.querySelector('.kuResults');

    if (filterElement && grid) {
        const filterHeight = filterElement.offsetHeight;
        const paddingValue = filterHeight + 20;

        grid.style.setProperty('padding-top', `${paddingValue}px`, 'important');
    }
}

function observeMutations() {
    const filterElement = document.querySelector('.kuFilterTagsContainer');
    if (!filterElement) {
        return;
    }

    // Create a MutationObserver to watch for changes in the .kuFilterTagsContainer element
    const observer = new MutationObserver(function (mutationsList, observer) {
        mutationsList.forEach(function (mutation) {
            // Watch for any changes in attributes, child elements, or subtree
            if (mutation.type === 'attributes' || mutation.type === 'childList' || mutation.type === 'subtree') {
                updatePadding();
            }
        });
    });

    // Configuration for observing changes in attributes, childList, and subtree
    const config = {
        attributes: true,
        childList: true,
        subtree: true
    };

    observer.observe(filterElement, config);
}



window._klvReady = window._klvReady || [];
window._klvReady.push(function () {
    klevu({
        theme: {
            modules: {
                resultInfiniteScroll: {
                    searchResultsPage: {
                        enable: true,
                    },
                    categoryPage: {
                        enable: true,
                    },
                },
            },
        },
    });
});


klevu.beforeActivation("catnav,landing", function (data, scope) {

    // Activate Load More button
    scope.kScope.chains.template.events.add({
        name: "hideLoadMoreButtonForWindowScroll",
        fire: function (data, scope) {
            return true;
        },
    });
    window.onscroll = function (ev) {
        if (
            window.innerHeight + Math.ceil(window.pageYOffset) >=
            document.body.offsetHeight - 50
        ) {
            var hasAlreadyTriggered = klevu.getObjectPath(
                klevu.search.landing.getScope().data,
                "context.triggeredFromInfiniteScroll"
            );
            if (!hasAlreadyTriggered) {
                return true;
            }
        }
    };
    // END OF Activate Load More button
});


// Set default limit to 24 products
klevu.interactive(function () {
    klevu({
        powerUp: {
            settings: {
                normalSearch: {
                    productListFallback: 24,
                    minProductsToDisplay: 24
                }
            }
        }
    });
});

// Update local storage limit
if (!localStorage.getItem("klv_limits_productList")) {
    localStorage.setItem("klv_limits_productList", "24");
}

// Ensure request limits are set to 24
klevu.modifyRequest("catnav,landing", function (data, scope) {
    klevu.each(data.request.current.recordQueries, function (key, query) {
        query.settings.limit = 24;
        query.filters.filtersToReturn.options.limit = 24;
    });
});